import React, { useEffect, useState } from "react";
import { Header } from "../components";
import SellersTable from "../components/Retailer/Tabela";
import api from "../api/api";
import Create from "../components/Retailer/Create";
import Alerts from "../components/Alerts";
import Edit from "../components/Retailer/Edit";
import { CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";

const Sellers = () => {
  const [sellersData, setsellersData] = useState([]);
  const [userToEdit, setUserToEdit] = useState({});
  const [step, setStep] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRetailers = async () => {
      setIsLoading(true);
      try {
        const res = await api.get("retailer");
        if (res.status === 200) {
          setsellersData(res.data.retailer);
        } else {
          setsellersData([]);
        }
      } catch (error) {
        setsellersData([]);
        setWarning({
          type: "error",
          message: "Erro ao carregar os Revendedores.",
        });
        handleOpenSnackbar();
      } finally {
        setIsLoading(false);
      }
    };

    fetchRetailers();
  }, []);

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleSave = () => {
    try {
      api.get("retailer").then((res) => {
        if (res.status === 200) {
          setsellersData(res.data.retailer);
          setStep("");
          setWarning({
            type: "success",
            message: "Lista de Revendedores Atualizados!",
          });
          handleOpenSnackbar();
        } else {
          setsellersData([]);
        }
      });
    } catch (error) {
      setWarning({
        type: "error",
        message: "Falha ao carregar os Revendedores!",
      });
      handleOpenSnackbar();
    }
  };

  const handleEdit = (client) => {
    setUserToEdit(client);
    setStep("edit");
  };

  const handleUpdate = async (id, data) => {
    try {
      await api.put(`users/${id}`, data);
      setWarning({
        type: "success",
        message: "Vendedor Atualizado!",
      });
      handleOpenSnackbar();
      // Atualiza a lista de Vendedores após a edição
      const res = await api.get("sellers");
      if (res.status === 200) {
        setsellersData(res.data.sellers);
      }
    } catch (error) {
      setWarning({
        type: "error",
        message: "Erro ao atualizar Vendedor.",
      });
      handleOpenSnackbar();
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Administrativo" title="Revendedores" />
      <div className="flex justify-between items-center mb-10">
        <button
          onClick={() => setStep(step === "create" ? "" : "create")}
          className="bg-blue-500 text-white px-4 py-2 rounded flex items-center gap-2"
        >
          {step === "create" ? (
            <div className="flex items-center gap-2">
              <ArrowBackIcon sx={{ fontSize: 16, color: "white" }} />
              Voltar
            </div>
          ) : step === "edit" ? (
            <div className="flex items-center gap-2">
              <ArrowBackIcon sx={{ fontSize: 16, color: "white" }} />
              Voltar
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <AddIcon sx={{ fontSize: 16, color: "white" }} />
              Criar Novo Revendedor
            </div>
          )}
        </button>
      </div>
      {isLoading ? (
        <div className="flex justify-center items-center h-40">
          <CircularProgress />
        </div>
      ) : step === "create" ? (
        <Create
          onSave={handleSave}
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
        />
      ) : step === "edit" ? (
        userToEdit && (
          <Edit
            seller={userToEdit}
            setWarning={setWarning}
            handleOpenSnackbar={handleOpenSnackbar}
            onClose={() => setStep("")}
            onSave={handleUpdate}
          />
        )
      ) : (
        <SellersTable clients={sellersData} onEdit={handleEdit} />
      )}
      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};

export default Sellers;
